module.exports = __webpack_public_path__ + "static/media/vibe.a348f668.svg";